module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("充值配置")])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "满100送"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "赠送金额"
    },
    model: {
      value: (_vm.form.giftAmount1),
      callback: function($$v) {
        _vm.$set(_vm.form, "giftAmount1", $$v)
      },
      expression: "form.giftAmount1"
    }
  }), _vm._v(" "), _c('span', [_vm._v("= 总金额: " + _vm._s(100 + (_vm.form.giftAmount1 | 0)))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "满200送"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "赠送金额"
    },
    model: {
      value: (_vm.form.giftAmount2),
      callback: function($$v) {
        _vm.$set(_vm.form, "giftAmount2", $$v)
      },
      expression: "form.giftAmount2"
    }
  }), _vm._v(" "), _c('span', [_vm._v("= 总金额: " + _vm._s(200 + (_vm.form.giftAmount2 | 0)))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "满300送"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "赠送金额"
    },
    model: {
      value: (_vm.form.giftAmount3),
      callback: function($$v) {
        _vm.$set(_vm.form, "giftAmount3", $$v)
      },
      expression: "form.giftAmount3"
    }
  }), _vm._v(" "), _c('span', [_vm._v("= 总金额: " + _vm._s(300 + (_vm.form.giftAmount3 | 0)))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "满400送"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "赠送金额"
    },
    model: {
      value: (_vm.form.giftAmount4),
      callback: function($$v) {
        _vm.$set(_vm.form, "giftAmount4", $$v)
      },
      expression: "form.giftAmount4"
    }
  }), _vm._v(" "), _c('span', [_vm._v("= 总金额: " + _vm._s(400 + (_vm.form.giftAmount4 | 0)))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "满500送"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "赠送金额"
    },
    model: {
      value: (_vm.form.giftAmount5),
      callback: function($$v) {
        _vm.$set(_vm.form, "giftAmount5", $$v)
      },
      expression: "form.giftAmount5"
    }
  }), _vm._v(" "), _c('span', [_vm._v("= 总金额: " + _vm._s(500 + (_vm.form.giftAmount5 | 0)))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "满1000送"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "赠送金额"
    },
    model: {
      value: (_vm.form.giftAmount6),
      callback: function($$v) {
        _vm.$set(_vm.form, "giftAmount6", $$v)
      },
      expression: "form.giftAmount6"
    }
  }), _vm._v(" "), _c('span', [_vm._v("= 总金额: " + _vm._s(1000 + (_vm.form.giftAmount6 | 0)))])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-1b3acc54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/giftCard/buyConfig.vue
// module id = 1604
// module chunks = 0